import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import NumberFormat from 'react-number-format';
import SuccessCreditMemoTableHead from './SuccessCreditMemoTableHead';
import SuccessCreditMemoToolBar from './SuccessCreditMemoToolBar';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        padding:theme.spacing.unit
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    tableCell: {
        padding: '4px 16px'
    },
    paymentDetails: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        padding: theme.spacing.unit
    },
    rightAlign: {
        textAlign: 'right'
    },
});


class SuccessCreditMemoTable extends Component{

    constructor(props) {
        super(props);
        this.state = {          
            selected: [],
            data: this.props.data,
            selectedCurrencyInvoices: 0
        };
    }

    totalPaymentAmount = () => {
        let creditTotalPayableAmount = this.state.data.creditmemoDetails.filter(credit => credit.entryNo).reduce((accumulator, credit) => {
         return accumulator + (+credit.invoiceAmount)
     },  0);
    return  creditTotalPayableAmount
 }   
    
    render() {
        const { data,  selected} = this.state;
        const { classes } = this.props;
        let customerDetails = JSON.parse(localStorage.getItem('customer'));
       return (
            <div>
                <Paper className={classes.root}>
                    <div className={classes.tableWrapper}>
                    <SuccessCreditMemoToolBar/>
                        <Table className={classes.table} aria-labelledby="tableTitle">                    
                        <SuccessCreditMemoTableHead
                        numSelected={selected.length}
                       />
                       <TableBody>
                                {data['creditmemoDetails'].map(n => {                                   
                                    return (
                                        <TableRow key={n.entryNo}>
                                            <TableCell component="th" scope="row">
                                                {n.invoiceNumber}
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>{n.invoiceDate}</TableCell>
                                            <TableCell numeric className={classes.tableCell}>
                                            <NumberFormat value={+n.invoiceAmount} 
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={customerDetails.currencyCode === 'CAD'?'CAD ':'$'}/>                                                   
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                                 {data['creditmemoDetails'].length === 0 && <TableRow style={{ height: 49 * 3 }}>
                                    <TableCell colSpan={3}>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            No credit memo selected
                                        </Typography>
                                    </TableCell>
                                </TableRow>}                                
                            </TableBody>                      
        </Table>        
        </div>
        
        <Grid container spacing={24} justify="space-around">
                        <Grid item xs={12}>
                            <Typography variant="subheading" align="right">
                            <NumberFormat value={this.totalPaymentAmount()}
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={(customerDetails.currencyCode === 'CAD')?'Total Credit Memo: CAD ':'Total Credit Memo: $'}/>                                                                                
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subheading" align="center">
                            <NumberFormat value={data['paymentAmount']}
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={(customerDetails.currencyCode === 'CAD')?'Total Amount Paid: CAD ':'Total Amount Paid: $'}/>                                                                                
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subheading" align="center">
                                Transaction ID: {data.transactionId}
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subheading" align="right">
                                Dated: {data.transactionDate}
                            </Typography>
                        </Grid>
                    </Grid>
        </Paper>
        </div>
       
        )


    }

}


SuccessCreditMemoTable.propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object,
};
export default withStyles(styles)(SuccessCreditMemoTable);


// WEBPACK FOOTER //
// ./src/SuccessCreditMemoTable.js